<template>
    <div>
        <main class="flex flex-col overflow-visible border-gray-200 border rounded-2xl p-2 bg-white" :key="key">
            <div class="ml-2 flex" v-if="user == null">
                Loading user data....
            </div>
            <div class="mx-2 pb-2" v-else>
                <div class="text-lg mb-1">Documents :</div>
                <div class="overflow-visible">
                    <div
                        class="flex border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold ">
                        <div class="w-72 border-l border-gray-200 px-2 py-1">Document</div>
                        <div class="w-48 border-l border-gray-200 px-2 py-1">Status</div>
                        <div class="flex-1 border-l border-gray-200 px-2 py-1">Files</div>
                        <div class="w-6 border-l border-gray-200 flex-shrink-0"></div>
                    </div>
                    <div class="flex -mt-px border-t border-b border-gray-200 bg-white"
                         v-for="document in wallet">
                        <div
                            class="w-72 mx-0 mb-px border-l p-px border-gray-200 truncate text-gray-500 relative"
                            :class="documentIdCurrentlyEditing === document.id?'hover:bg-blue-50 cursor-pointer':''"
                            @click="(documentIdCurrentlyEditing === document.id)?edit(document.id):false">
                            <page-cell
                                :ref="'doc-'+document.id"
                                class="text-gray-600 border-none text-gray-500 m-0 p-1 py-1 px-2 text-base"
                                v-model="document.name"
                                v-if="documentIdCurrentlyEditing === document.id"
                                @input="save(document.id)"
                                @change="save(document.id)"
                            ></page-cell>
                            <div v-else v-text="document.name"
                                 class="text-gray-600 border-none truncate text-gray-500 m-0 p-1 py-1 px-2 text-base"
                            ></div>
                            <div class="text-xs text-gray-400 truncate mx-2" v-if="document.lastUpdated">Last updated
                                {{ moment(document.lastUpdated).format('Do MMMM YYYY, h:mm a') }}
                            </div>
                        </div>
                        <div
                            class="w-48 ml-0 mb-px mr-px border-l border-gray-200 truncate text-gray-500 px-2 py-1 relative"
                            :class="documentIdCurrentlyEditing === document.id?'hover:bg-blue-50 cursor-pointer':''"
                            @click="(documentIdCurrentlyEditing === document.id)?openDate(document.id):false"
                        >
                            <div class="absolute opacity-0 h-1 w-1 block top-2 overflow-hidden">
                                <ui-date-picker v-model="document.expires" :ref="'date-'+document.id"
                                                @input="save(document.id)"
                                ></ui-date-picker>
                            </div>
                            <div class="text-gray-600 w-full truncate text-red-600"
                                 v-if="document.expires && moment(document.expires).isValid() && (moment(document.expires) < moment())">
                                Expired
                            </div>
                            <div class="text-gray-600 w-full truncate text-green-600" v-else>Valid</div>
                            <div class="text-xs text-gray-400 mt-0 truncate"
                                 v-if="document.expires && moment(document.expires).isValid()">
                                <div class="inline-block"
                                     v-text="'Expires '+  moment(document.expires).format('Do MMMM YYYY')"></div>
                                <div class="inline-block ml-1"><span
                                    class="fa fa-times text-red-400 border border-gray-200 py-0.5 px-1 rounded bg-gray-50 hover:bg-gray-100 opacity-40 hover:opacity-100"
                                    @click.stop="document.expires = '';save(document.id)"></span></div>
                            </div>
                            <div v-else class="text-xs text-gray-400 mt-0 truncate">Does not expire</div>
                        </div>
                        <div
                            class="flex-1 ml-0 mb-px border-l border-gray-200 truncate text-gray-500 p-1">
                            <ui-input-file-inline name="files"
                                                  :filesystemId="user.filesystemId"
                                                  :readonly="documentIdCurrentlyEditing !== document.id"
                                                  :attachUrl="(fileId) => attachUrl(document.id,fileId)"
                                                  :detachUrl="(fileId) => detachUrl(document.id,fileId)"
                                                  :downloadUrl="(fileId) => downloadUrl(document.id,fileId)"
                                                  :current-files="() => getDocumentFiles(document.id)"></ui-input-file-inline>
                            <div v-if="documentIdCurrentlyEditing === document.id">
                                <ui-button-new extra small class="whitespace-nowrap mt-1"
                                               @click="documentIdCurrentlyEditing = false">
                                    Finish editing document
                                </ui-button-new>
                            </div>
                        </div>
                        <div class="w-6 border-l border-gray-200 flex-shrink-0 ">
                            <ui-dropdown menu-class="p-3 w-72">
                                <template #default="{ toggle }">
                                    <button @click="toggle"
                                            class="w-3 h-3 mt-3 ml-1 flex items-center justify-center text-gray-300 text-xs hover:text-gray-500 focus:outline-none focus:ring-0 focus:z-10 relative rounded">
                                        <i class="fa fa-ellipsis-h"></i>
                                    </button>
                                </template>
                                <template #menu="{ close }">
                                    <ui-dropdown-item icon="fas fa-edit"
                                                      v-if="documentIdCurrentlyEditing !== document.id"
                                                      @click="documentIdCurrentlyEditing = document.id;close()">
                                        Edit Document
                                    </ui-dropdown-item>
                                    <ui-dropdown-item icon="fas fa-check"
                                                      v-else
                                                      @click="documentIdCurrentlyEditing = false;close()">
                                        Finish Editing
                                    </ui-dropdown-item>
                                    <ui-dropdown-divider/>
                                    <ui-dropdown-item icon="fas fa-trash" danger
                                                      @click="removeDocument(document);close()">
                                        Remove Document
                                    </ui-dropdown-item>
                                </template>
                            </ui-dropdown>
                        </div>
                    </div>
                    <div class="flex -mt-px border-gray-200 bg-white mb-1">
                        <div class="w-6 flex-shrink-0 self-start py-1.5 border-t">
                            <i class="fa fa-plus text-xs text-gray-300 pl-1 pt-1"></i>
                        </div>
                        <div class="flex-1 border-gray-200">
                            <input
                                placeholder="Add new Document to wallet..."
                                class="text-sm m-0 px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-30 resize-none bg-white"
                                type="text"
                                v-model="newDocument"
                                @input="addDocument()"
                            >
                        </div>
                        <div class="w-6 border-gray-200 flex-shrink-0"></div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import moment from "moment";
import User from "../../services/User";
import UiButton from "../ui/UiButton.vue";
import UiDropdown from "../ui/UiDropdown.vue";
import UiInputFileInline from "../filesystem/inline/UiInputFileInline.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import {uuid} from "../../utils";
import PageCell from "../ui/PageCell.vue";
import UiDatePicker from "../ui/UiDatePicker.vue";

export default {
    components: {UiDatePicker, PageCell, UiButtonNew, UiInputFileInline, UiDropdown, UiButton},
    props: [],
    data() {
        return {
            user: null,
            wallet: [],
            key: 0,
            moment,
            documentIdCurrentlyEditing: false,
            newDocument: '',
            lastUpdate: 0,
            lastUpdated: 1,
            editing:false,
        }
    },
    watch: {
        user: {
            handler(newValue, oldValue) {
            },
            deep: true,
        },
    },
    computed: {},
    methods: {
        removeDocument(document) {
            this.$modals.confirmDelete({
                title: `Remove ${document.name}?`,
                button: 'Yes, remove this document',
                handle: async () => {
                    try {
                        await Http.delete(route('api.v2.organization.user.wallet.delete', [document.id]))
                        this.lastUpdate = new Date().getTime();
                        await this.loadDocumentFiles();
                    } catch (error) {
                        let body = JSON.parse(error.request.response);
                        setTimeout(() => {
                            this.$nextTick(() => {
                                this.$modals.error(
                                    {
                                        title: `Cannot remove ${document.name}`,
                                        paragraphs: [`Document ${document.id} cannot be removed`, body.message]
                                    },
                                )
                            })
                        }, 200)
                    }
                }
            })
        },
        async save(documentId) {
            await Http.put(route('api.v2.organization.user.wallet.update', documentId), this.wallet.find((i) => i.id == documentId));
        },
        openDate(documentId) {
            this.documentIdCurrentlyEditing = documentId;
            this.$nextTick(() => {
                this.$refs['date-' + documentId][0].flatpickr.open()
            })
        },
        edit(documentId) {
            this.documentIdCurrentlyEditing = documentId;
            this.$nextTick(() => {
                this.$refs['doc-' + documentId][0].focusAsNew()
            })
        },
        async addDocument() {
            let newId = uuid()
            let document = {
                id: newId,
                name: this.newDocument,
                lastUpdatedAt: moment().format("YYYY-MM-DD"),
                expires: null,
                files: []
            };
            this.wallet.push(document)
            this.newDocument = '';
            this.edit(newId)
            await Http.post(route('api.v2.organization.user.wallet.create', newId), document);
        },
        attachUrl(documentId, id) {
            this.lastUpdate = new Date().getTime();
            return route('api.v2.organization.user.wallet.attach', [documentId, id])
        },
        detachUrl(documentId, id) {
            this.lastUpdate = new Date().getTime();
            return route('api.v2.organization.user.wallet.detach', [documentId, id])
        },
        downloadUrl(documentId, id) {
            return route('api.v2.organization.user.wallet.download', [documentId, id])
        },
        format(dateTime) {
            return moment(dateTime).format("HH:mm:ss [on] DD-MM-YYYY");
        },
        updateUserFromListener(event) {
        },
        async getDocumentFiles(documentId) {
            if (this.lastUpdate != this.lastUpdated) {
                this.lastUpdate = this.lastUpdated;
                await this.loadDocumentFiles()
            }
            return this.wallet.find((i) => i.id === documentId).files
        },
        async loadDocumentFiles() {
            let data = await Http.get(route('api.v2.organization.user.wallet'));
            this.wallet = data.wallet;
        }
    },
    async mounted() {
        await User.register();
        this.user = User.user;
        this.lastUpdate = this.lastUpdated;
        await this.loadDocumentFiles()
//        User.registerAggregate({"type": 'User', 'id': this.user.id}, this.updateUserFromListener)
    }
}
</script>
